import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../services/user.service';
import { NotificationsService } from 'angular2-notifications';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { AdminService } from "../services/admin.service";

@Component({
    selector: 'app-whitelistedaddress',
    templateUrl: './whitelistedaddress.component.html',
    styleUrls: ['./whitelistedaddress.component.css']
})
export class whitelistedAddressComponent implements OnInit {
    whitelistedAddress:any;
    userid:any;
    displayedColumns = ['currency', 'address', 'destinationTag', 'note', 'status'];
    dataSource: MatTableDataSource<whitelistData>;
    pageSize = 25;
    whitelistRes:any
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    constructor(
        private route: ActivatedRoute, 
        private userService: UserService,
        private adminService: AdminService,
        private notifSer: NotificationsService,
        ) { }

    ngOnInit() {
        this.userid = this.route.snapshot.paramMap.get('id');
        if (this.userid) {
            this.userService.csrf().subscribe((success) => {
                this.adminService.WithdrawWhitelist(0, 0, this.userid, success['_csrf']).subscribe(whitelistedAddresses => {
                    this.whitelistedAddress = whitelistedAddresses.addresslist;
                    let tableData = [];
                    for (const whitelistedAddress of this.whitelistedAddress) {
                        tableData.push({
                            currency: whitelistedAddress.currency, 
                            address: whitelistedAddress.address,
                            destinationTag: whitelistedAddress.destinationTag,
                            status: whitelistedAddress.status,
                            note: whitelistedAddress.note
                        });
                    }
                    this.dataSource = new MatTableDataSource(tableData);                    
                    this.dataSource.paginator = this.paginator;
                    this.dataSource.sort = this.sort;
                })
            });

        }

    }
    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.dataSource.filter = filterValue;
    }
}
export interface whitelistData  {
    currency: string,
    address: string,
    destinationTag: string,
    note: string,
    status: string,
}


// WEBPACK FOOTER //
// ./src/app/whitelistedAddress/whitelistedaddress.component.ts